export default class ModeSelector extends React.PureComponent
  constructor: (props) ->
    super(props)

    @state =
      pillType:  'buttons' # In ["buttons", "slider"], always start with button for SSR and then hydrate slider with correct position
      pillWidth: 0         # | => Only for "slider" pill
      pillLeft:  0         # /

    @containerRef = React.createRef()

    @dEnableSlider = _.debounce(@enableSlider.bind(this), 150) # 150ms is the time of the CSS slider transition

  componentDidMount: ->
    @initializeSlider() # Switching from the static SSR "button pill" to the dynamic front-end "slider pill"

    addEventListener('resize', @onResize.bind((this)))

  componentDidUpdate: (prevProps, prevState) ->
    if prevProps.mobileNavbarIsOpen != @props.mobileNavbarIsOpen
      # for mobile, we only use 'buttons' pillType
      if @props.mobileNavbarIsOpen
        @disableSlider()
      else
        @initializeSlider()

  initializeSlider: ->
    if @containerRef.current
      activeButton = @containerRef.current.querySelector('.active') # active button (if any)

      if activeButton
        @updateSliderSize(activeButton)
        @dEnableSlider()

  updateSliderSize: (activeButton) ->
    @setState(
      pillWidth: activeButton.offsetWidth
      pillLeft:  activeButton.offsetLeft
    )

  enableSlider: ->
    @setState(pillType: 'slider')

  disableSlider: ->
    @setState(pillType: 'buttons')

  onResize: ->
    @disableSlider()    # No weird animation during resizing
    @initializeSlider() # ...Then recompute positions and display slider

  changeMode: (mode, e) ->
    e.preventDefault() # don't really follow href

    @updateSliderSize(e.target)

    @props.changeMode(mode)

  render: ->
    modes   = ['text', 'files', 'apps']
    classes = "navbar-nav modes for-#{@state.pillType}" # for-slider or for-button

    <div className={classes} ref={@containerRef}>
      { modes.map((mode) => @renderMode(mode)) }
      { @renderPill() if modes.includes(@props.activeMode) }
    </div>

  renderMode: (mode) ->
    classes = ""
    classes += ' active' if mode == @props.activeMode

    <a href="/#{@props.currentLocale}/#{mode}"
       key={mode}
       className={classes}
       type="button"
       onClick={@changeMode.bind(this, mode)}>
      {@props.i18n[mode]}
    </a>

  renderPill: ->
    style =
      width: @state.pillWidth
      left:  @state.pillLeft

    <span className="sliding-pill" style={style} />
